import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const brBackupSchema: Schema = {
  title: 'BR Backup If Running',
  level: 2,
  columns: commonColumns
}
